import { useQuery } from '@tanstack/react-query';
import { api } from '../../config';

export interface DeletedCustomerUser {
  id: string;
  customerId: string;
  email: string;
  name: string | null;
  deletedAt: string;
  deletedBy: string | null;
  deletionReason: string | null;
  deletedByUser: { id: string; email: string; name: string | null } | null;
  customer: { customerId: string; name: string } | null;
  daysUntilPermanentDeletion: number;
}

export function useDeletedCustomerUsers() {
  return useQuery<DeletedCustomerUser[]>({
    queryKey: ['customerUsers', 'trash'],
    queryFn: async () => {
      return await api.get<DeletedCustomerUser[]>('/api/v1/admin/customer-users/trash');
    },
  });
}

export function useDeletedCustomerUsersCount() {
  return useQuery<{ count: number }>({
    queryKey: ['customerUsers', 'trash', 'count'],
    queryFn: async () => {
      return await api.get<{ count: number }>('/api/v1/admin/customer-users/trash/count');
    },
  });
}
